import Axios from 'axios'

export const getAgingDashboard = async (seller) => {
  const params = {}
  if (seller) params.seller = seller
  const response = await Axios.get('/AgingAnalysis/dashboard', { params })
  return response.data
}

export const getAgingTable = async (filters = {}) => {
  const params = {}
  Object.keys(filters).forEach((key) => {
    const value = filters[key]
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value
    }
  })
  const response = await Axios.get('/AgingAnalysis/table', { params })
  return response.data
}

export const getZoneBreakdown = async (seller) => {
  const params = {}
  if (seller) params.seller = seller
  const response = await Axios.get('/AgingAnalysis/zoneBreakdown', { params })
  return response.data
}

export const getCollectionDays = async (seller) => {
  const params = {}
  if (seller) params.seller = seller
  const response = await Axios.get('/CollectionDays/list', { params })
  return response.data
}

export const getSalesTarget = async (seller) => {
  const params = {}
  if (seller) params.seller = seller
  const response = await Axios.get('/SalesTarget/list', { params })
  return response.data
}

export const uploadAgingAnalysis = async (file) => {
  const formData = new FormData()
  formData.append('agingAnalysis', file, file.name)
  const response = await Axios.post('/AgingAnalysis/upload', formData, {
    timeout: 300000,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const uploadCollectionDays = async (file) => {
  const formData = new FormData()
  formData.append('collectionDays', file, file.name)
  const response = await Axios.post('/CollectionDays/upload', formData, {
    timeout: 300000,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const uploadSalesTarget = async (file) => {
  const formData = new FormData()
  formData.append('salesTarget', file, file.name)
  const response = await Axios.post('/SalesTarget/upload', formData, {
    timeout: 300000,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}
